import Cookies from "js-cookie";

const setCurrency = (currency: string, locales: string) => {
    Cookies.set("currency", currency);
    Cookies.set("currency_locales", locales);
};

const getCurrency = () => {
    const currencyCookies = {
        locales: Cookies.get("currency_locales") ?? "ja",
        currency: Cookies.get("currency") ?? "JPY",
    };
    return currencyCookies;
};

export { setCurrency, getCurrency };